import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
                 title = "LegalTitan - Ձեր իրավաբանական վստահելի գործընկերը",
                 description = "LegalTitan.am – հուսալի իրավաբանական ծառայություններ Հայաստանում։ Փորձառու իրավաբաններ, պաշտպանություն և խորհրդատվություն տարբեր իրավական ոլորտներում։",
                 keywords = "իրավաբան, իրավաբանական ծառայություններ, իրավաբանական աջակցություն, իրավական խորհրդատվություն, կորպորատիվ իրավունք, քաղաքացիական իրավունք",
                 url = "https://legaltitan.am/home",
                 image = "https://legaltitan.am/assets/images/legalLogo.jpg",
                 fbAppId = "61557661694303",
                 structuredData = null
             }) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={url} />

            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={image} />

            <meta property="fb:app_id" content={fbAppId} />

            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
